import {ChangeDetectorRef, Component, inject, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogActions, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {MatListOption, MatSelectionList} from '@angular/material/list';
import {
  ConfirmIconButtonComponent
} from 'frontier/browserkit/src/lib/components/confirm-icon-button/confirm-icon-button.component';
import {FormControl, FormsModule} from '@angular/forms';
import {DialogHeaderComponent} from 'frontier/browserkit/src/lib/components/dialog-header/dialog-header.component';
import {ISelectableEntity} from "frontier/browserkit/src/lib/dialogs/entity-selector/selectable-entity.interface";
import {MatCheckbox} from "@angular/material/checkbox";
import {ISelectFormOption, SelectElementComponent, TextElementComponent} from "frontier";
import {ECountry} from "frontier/browserkit/src/lib/enums/countries.enum";

export enum EJobType {
  manual,
  epost,
  not,
  email,
}

export interface IDispatchTypeSelectorDialogData {
  entities: ISelectableEntity[];
  title: string;
  address: IAddress;
}

export interface IDispatchTypeSelectorDialogReturnData {
  selectedEntry: EJobType;
  changeAddress: boolean;
  address: IAddress;
}

export interface IAddress {
  addressline1: string;
  addressline2: string;
  addressline3: string;
  street: string;
  postcode: string;
  city: string;
  country: number;
}

@Component({
  selector: 'app-entity-selector',
  templateUrl: './dispatch-type-selector.component.html',
  styleUrls: ['./dispatch-type-selector.component.scss'],
  standalone: true,
  imports: [
    DialogHeaderComponent,
    MatDialogContent,
    MatSelectionList,
    FormsModule,
    MatListOption,
    MatDialogActions,
    ConfirmIconButtonComponent,
    MatCheckbox,
    TextElementComponent,
    SelectElementComponent,
  ],
})
export class DispatchTypeSelectorComponent {
  selectedEntities: ISelectableEntity[] = [];
  changeAddress: boolean = false;
  cdr: ChangeDetectorRef = inject(ChangeDetectorRef);

  dialog: MatDialog = inject(MatDialog);

  countries: ISelectFormOption[] = Object.keys(ECountry)
    .filter((key: string): boolean => isNaN(Number(key))) // Only keep string names
    .map((name: string): ISelectFormOption => ({
      name,
      value: ECountry[name as keyof typeof ECountry],
    }));

    addressline1: FormControl<string> = new FormControl('');
    addressline2: FormControl<string> = new FormControl('');
    addressline3: FormControl<string> = new FormControl('');
    street: FormControl<string> = new FormControl('');
    postcode: FormControl<string> = new FormControl('');
    city: FormControl<string> = new FormControl('');
    country: FormControl<number> = new FormControl(null);


  constructor(
    public dialogRef: MatDialogRef<DispatchTypeSelectorComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDispatchTypeSelectorDialogData,
  ) {
    if(data && data.address) {
      this.addressline1.patchValue(data.address.addressline1);
      this.addressline2.patchValue(data.address.addressline2);
      this.addressline3.patchValue(data.address.addressline3);
      this.street.patchValue(data.address.street);
      this.postcode.patchValue(data.address.postcode);
      this.city.patchValue(data.address.city);
      this.country.patchValue(data.address.country);
    }
  }

  onConfirm(): void {
    this.dialogRef.close({
      selectedEntry: this.selectedEntities[0],
      changeAddress: this.changeAddress,
      address: this.changeAddress ? {
        addressline1: this.addressline1.value,
        addressline2: this.addressline2.value,
        addressline3: this.addressline3.value,
        street: this.street.value,
        postcode: this.postcode.value,
        city: this.city.value,
        country: this.country.value,
      } : null,
    });
  }
}
